<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  mode: {
    type: String,
    required: true,
    validator: value => ['bot', 'human'].includes(value),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['takeOver', 'returnToBot']);

const selectBot = () => {
  if (props.mode !== 'bot' && !props.isLoading) emit('returnToBot');
};

const selectHuman = () => {
  if (props.mode !== 'human' && !props.isLoading) emit('takeOver');
};
</script>

<template>
  <div
    class="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-b border-n-weak"
  >
    <div class="flex items-center gap-3 min-w-0">
      <span
        class="flex items-center justify-center flex-shrink-0 rounded-full size-9"
        :class="
          mode === 'bot'
            ? 'bg-n-iris-3 text-n-iris-11'
            : 'bg-n-blue-3 text-n-blue-11'
        "
      >
        <span
          class="size-4"
          :class="mode === 'bot' ? 'i-woot-captain' : 'i-lucide-user-round'"
        />
      </span>
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-medium text-n-slate-12">
          {{
            mode === 'bot'
              ? $t('CONVERSATION.BOT_HANDOFF.BOT_TITLE')
              : $t('CONVERSATION.BOT_HANDOFF.HUMAN_TITLE')
          }}
        </span>
        <span v-if="mode === 'bot'" class="text-xs text-n-slate-11">
          {{ $t('CONVERSATION.BOT_HANDOFF.BOT_DESCRIPTION') }}
        </span>
      </div>
    </div>

    <div
      class="flex w-full gap-1 p-1 rounded-xl bg-n-alpha-2 sm:w-auto"
      role="group"
      :aria-label="
        mode === 'bot'
          ? $t('CONVERSATION.BOT_HANDOFF.BOT_TITLE')
          : $t('CONVERSATION.BOT_HANDOFF.HUMAN_TITLE')
      "
    >
      <Button
        :label="$t('CAPTAIN.NAME')"
        icon="i-woot-captain"
        size="sm"
        class="flex-1 sm:flex-none"
        :variant="mode === 'bot' ? 'solid' : 'ghost'"
        :color="mode === 'bot' ? 'blue' : 'slate'"
        :aria-pressed="mode === 'bot'"
        :is-loading="isLoading && mode === 'human'"
        :disabled="isLoading"
        @click="selectBot"
      />
      <Button
        :label="$t('AGENT_MGMT.AGENT_TYPES.AGENT')"
        icon="i-lucide-user-round"
        size="sm"
        class="flex-1 sm:flex-none"
        :variant="mode === 'human' ? 'solid' : 'ghost'"
        :color="mode === 'human' ? 'blue' : 'slate'"
        :aria-pressed="mode === 'human'"
        :is-loading="isLoading && mode === 'bot'"
        :disabled="isLoading"
        @click="selectHuman"
      />
    </div>
  </div>
</template>
